import { useGSAP } from "@gsap/react";
import BottomArrow from "../../components/assets/BottomArrow";
import gsap from "gsap";
import ProjectCaroussel from "../../components/layout/ProjectsCaroussel";
import { Link } from "react-router-dom";
import BlueButton from "../../components/buttons/BlueButton";
import ArrowUpRight from "../../components/icons/ArrowUpRight";
import { useRef } from "react";
import WorksCaroussel from "../WorksCaroussel";
import { useMediaQuery } from "react-responsive";

export default function Works() {
    const scrollAnnouncementRef = useRef(null);
    const isMobile = useMediaQuery(
        {
            query: "(max-width: 780px)"
        }
    )

    const mobileAnimationTimeline = useRef(gsap.timeline(
        {
            repeat: -1
        }
    ));

    useGSAP(() => {
        mobileAnimationTimeline.current.clear();
        gsap.set(scrollAnnouncementRef.current,{
            yPercent: isMobile ? -200 : 0,
            y: 0
        });
        if(!isMobile){
            gsap.to(scrollAnnouncementRef.current, {
                delay: 2,
                yPercent: -100
            });
        } else {
            mobileAnimationTimeline.current.to(scrollAnnouncementRef.current,{
                y: -20,
                duration: 1
            }).to(scrollAnnouncementRef.current,{
                y: 0,
                duration: 1
            })
        }
    },[isMobile]);
    return (
        <div className="bg-white mb-[7rem] relative z-50">
            <div className="flex justify-center items-center gap-[2.1875rem] py-[1rem] rounded-t-[3.4375rem] bg-white mobile:rounded-b-[3.4375rem] mobile:w-fit mobile:mx-auto mobile:py-3 mobile:px-6" ref={scrollAnnouncementRef}>
                <div className="w-[2rem] aspect-square text-zoeil-blue">
                    <BottomArrow />
                </div>
                <div className="text-[1.46rem] font-[800]">
                    Voir nos réalisations ?
                </div>
                <div className="w-[2rem] aspect-square text-zoeil-blue">
                    <BottomArrow />
                </div>
            </div>
            <WorksCaroussel/>
        </div>
    )
}